import { CONTENT_TYPES, SOCIAL_PLATFORMS } from '~/constants';
import { CreatorBenchmarks, ValueOf } from '~/types';

import { IMetric } from '../../MediaPackDetailEditHighlightsModal/MediaPackDetailEditHighlightsModal.types';
import { MetricCardData } from './OveriewSection.types';

export const mapMetricsToMetricCardData = (
  metrics: string[],
  platformMetrics: IMetric[],
  creatorBenchmarks: CreatorBenchmarks,
) =>
  metrics.reduce((acc, value) => {
    const metric = platformMetrics.find((m) => m.key === value);

    if (metric) {
      acc.push({
        key: metric.key,
        tooltipInfo: metric.description,
        label: metric.title,
        value: metric.transformValue
          ? metric.transformValue(creatorBenchmarks[metric.key], '')
          : NaN,
      });
    }

    return acc;
  }, [] as MetricCardData[]);

export const mapSubmitDataToUpdateMediaPackValues = <T>({
  selectedContent,
  ...submitValues
}: {
  selectedContent: T[];
  selectedContentType: ValueOf<typeof CONTENT_TYPES>;
  platform: SOCIAL_PLATFORMS;
}) => ({
  contents: selectedContent,
  ...submitValues,
});
